import { Icon } from '@neshane/blueberry';
import { useId } from 'react';
import { NavLink as RRNavLink, matchPath } from 'react-router-dom';

export const NavLink = ({ href, iconName, children, activePaths, pulse = false, end = false }) => {
  const textId = useId();
  return (
    <RRNavLink
      to={href}
      className="navigation-item h-40"
      aria-labelledby={textId}
      isActive={(_, location) => {
        const paths = activePaths && activePaths.length > 0 ? activePaths : [href];
        return paths.some((path) => matchPath({ path, end }, location.pathname) !== null);
      }}
    >
      <div className="relative flex items-center">
        <Icon name={iconName} size="m" aria-hidden="true" className="shrink-0" />
        {pulse && (
          <div className="absolute -right-8 -top-8 h-8 w-8 animate-pulse rounded-8 bg-primary-alert-default" />
        )}
      </div>
      <span id={textId} className="navigation-toggle-display">
        {children}
      </span>
    </RRNavLink>
  );
};